<template>
    <div>
        <img :src="config.img" :style="getStyle">
    </div>

</template>


<script>
    export default {
        name: 'img-block',
        props: {
            config: {},
            componentData: {},


        },
        data() {
            return {}
        },
        computed: {
            getStyle() {
                var CSS_STRING = "color:" + this.config.style.color + ";"
                CSS_STRING += "background:" + this.config.style.background + ";"
                CSS_STRING += "height:" + this.config.style.height + ";"
                CSS_STRING += "padding:" + this.config.style.padding + ";"
                return CSS_STRING

            }
        },
        created() {

        }
    }
</script>
<style lang="scss" scoped>
    img {
        width: 100%;
    }

</style>